export class ColumnData {
    public dataType: string;
    public displayName: string;
    public fieldName: string;
    public enableInFooter: boolean;

    constructor(obj: Partial<ColumnData>) {
        this.dataType = obj?.dataType;
        this.displayName = obj?.displayName;
        this.fieldName = obj?.fieldName;
        this.enableInFooter = obj?.enableInFooter || false;
    }
}
